import React, { useState, useEffect } from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import CloseIcon from '@mui/icons-material/Close';
import TextsmsIcon from '@mui/icons-material/Textsms';
import './FloatingContact.css';

const FloatingContact: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    // Show after a small delay on page load
    const timer = setTimeout(() => setIsVisible(true), 2000);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={`floating-contact ${isVisible ? 'visible' : ''}`}>
      {isExpanded && (
        <div className="floating-contact-menu">
          <a href="tel:954-560-6839" className="floating-contact-option call">
            <PhoneIcon /> Call Now
          </a>
          <a href="sms:954-560-6839" className="floating-contact-option text">
            <TextsmsIcon /> Send Text
          </a>
        </div>
      )}
      <button 
        className={`floating-contact-btn ${isExpanded ? 'expanded' : ''}`}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-label="Contact options"
      >
        {isExpanded ? <CloseIcon /> : <PhoneIcon />}
        {!isExpanded && <span className="floating-contact-pulse"></span>}
      </button>
    </div>
  );
};

export default FloatingContact;
